"use strict";

var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Circle = void 0;

var Range_1 = require("./Range");

var Circle = /*#__PURE__*/function (_Range_1$Range) {
  _inherits(Circle, _Range_1$Range);

  var _super = _createSuper(Circle);

  function Circle(x, y, radius) {
    var _this;

    _classCallCheck(this, Circle);

    _this = _super.call(this, x, y);
    _this.radius = radius;
    return _this;
  }

  _createClass(Circle, [{
    key: "contains",
    value: function contains(point) {
      var d = Math.pow(point.x - this.position.x, 2) + Math.pow(point.y - this.position.y, 2);
      return d <= this.radius * this.radius;
    }
  }, {
    key: "intersects",
    value: function intersects(range) {
      var rect = range;
      var circle = range;
      var pos1 = this.position;
      var pos2 = range.position;
      var xDist = Math.abs(pos2.x - pos1.x);
      var yDist = Math.abs(pos2.y - pos1.y);
      var r = this.radius;

      if (circle.radius !== undefined) {
        var rSum = r + circle.radius;
        var dist = Math.sqrt(xDist * xDist + yDist + yDist);
        return rSum > dist;
      } else if (rect.size !== undefined) {
        var w = rect.size.width;
        var h = rect.size.height;
        var edges = Math.pow(xDist - w, 2) + Math.pow(yDist - h, 2);

        if (xDist > r + w || yDist > r + h) {
          return false;
        }

        if (xDist <= w || yDist <= h) {
          return true;
        }

        return edges <= r * r;
      }

      return false;
    }
  }]);

  return Circle;
}(Range_1.Range);

exports.Circle = Circle;